import { ID } from '@datorama/akita';

export class Household {
  costs: {
    life_insurance: 0;
    mortgage: 0;
  };
  goals_amount: 0;
  monthly_income: 0;
  name: 'Family';
  saving_percentage: 0;
  savings: object | {
    mortgage: 0;
    life_insurance: 0;
  };
  total_cost: 0;
  total_saving: 0;
}

export function createHousehold(params: Partial<Household>) {
  return {

  } as Household;
}
